import * as React from "react";
import { RenderCoupon } from "..";
import ImageView from "views/components/SmartImage";

export interface CouponBtnProps {
  coupon: RenderCoupon;
  handleClick: (code: string, index: number) => void;
  index?: number;
  placeholderBg?: string;
}

export const CouponBtn = (props: CouponBtnProps) => {
  const { coupon, index = 0, handleClick, placeholderBg } = props;
  const onClick = () => {
    handleClick(coupon?.code, index);
  };
  // return <img src={coupon?.img} onClick={onClick} />;
  return (
    <section onClick={onClick}>
      <ImageView
        src={coupon?.img}
        placeholder={placeholderBg}
        style={{ with: "100%", height: "100%", objectFit: "fill" }}
        alt=""
      />
    </section>
  );
};
